export default "__VITE_ASSET__hUFM28jW__"